const projects = [
  {
    name: "Autonomous Minesweeper Agent",
    type: "ml",
    link: "https://github.com/rizhkh/mswp",
    labels: ["A.I.", "Python"],
    description: "Autonomous Minesweeper agent using propositional logic inference, deterministic constraint rules, and probabilistic tracking to execute optimal, risk-mitigated moves",
    icon: "https://cdn.iconscout.com/icon/premium/png-512-thumb/minesweeper-1616681-1377688.png?f=webp&w=256"
  },
  {
    name: "Quantitative Forecasting Engine",
    type: "ml",
    link: "https://github.com/rizhkh/quant-edge",
    labels: ["Python", "ML", "Finance"],
    description: "Quantitative stock forecasting system using analog pattern matching (KNN) and ML models to forecast price ranges and direction signals",
    emoji: "📈"
  },
  {
    name: "Image Classifier",
    type: "ml",
    link: "https://github.com/rizhkh/Image-Classifier",
    labels: ["A.I.", "ML & Data", "Python"],
    description: "Implemented an image classifier from scratch using NumPy and scikit-learn — covers feature extraction, normalization, and k-nearest neighbor classification",
    icon: "https://img.icons8.com/?size=100&id=Hq6iYi45MXDH&format=png&color=000000"
  },
  {
    name: "Navigator",
    type: "ml",
    link: "https://github.com/rizhkh/mazesearch",
    labels: ["Python", "A.I."],
    description: "AI agent that navigates randomly generated 2D worlds with obstacles — implements BFS, DFS, and A* path-finding to find optimal routes",
    icon: "https://img.icons8.com/?size=100&id=KgWXEuIORpk7&format=png&color=000000"
  },
  {
    name: "Peer-to-Peer File Transfer",
    type: "software",
    link: "https://github.com/rizhkh/Socket-programming-Client",
    labels: ["Java", "Python", "PyNaCL"],
    description: "Encrypted peer-to-peer file transfer over TCP with public-private key cryptography via PyNaCL — supports chunked transfers and connection negotiation",
    icon: "https://img.icons8.com/?size=100&id=dyOz65O7jURH&format=png&color=000000"
  },
  {
    name: "Chess",
    type: "software",
    link: "https://github.com/rizhkh/GameOfChess",
    labels: ["JavaFX", "Android", "Gradle"],
    description: "Full chess engine in Java with an AI opponent (minimax + alpha-beta pruning), multiplayer support, and an Android build via Gradle",
    icon: "https://img.icons8.com/?size=100&id=64610&format=png&color=000000"
  },
  {
    name: "Music Player",
    type: "software",
    link: "https://github.com/rizhkh/MusicSongPlaylist",
    labels: ["JavaFX", "JSyn"],
    description: "Music player and playlist manager in JavaFX with real-time audio synthesis and waveform control via the JSyn library",
    icon: "https://img.icons8.com/?size=100&id=EHtxO8ZmA602&format=png&color=000000"
  },
  {
    name: "System Utilities",
    type: "software",
    link: "https://github.com/rizhkh/System-Utility-Malloc-free",
    labels: ["C"],
    description: "Implemented malloc and free from scratch in C — manages heap memory using explicit free lists, block coalescing, and first-fit placement",
    icon: "https://img.icons8.com/?size=100&id=11151&format=png&color=000000"
  },
  {
    name: "Photo Viewer & Storage Platform",
    type: "software",
    link: "https://github.com/rizhkh/PhotoAlbum",
    labels: ["Java", "JavaScript"],
    description: "Full-stack photo viewer with a Java backend and JavaScript frontend — supports album organization and a cloud storage layer",
    icon: "https://img.icons8.com/?size=100&id=13071&format=png&color=000000"
  }
];

export default projects;
